import React, { useState, useRef, useContext, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import CarouselCard from '../components/CarouselCard.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import companyLogo from '../content/img/logo-w.png';
import Header from '../components/Header';
import Video from '../components/Video';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CarouselOffer from '../components/CarouselOffer.js';
import { ParallaxProvider } from "react-scroll-parallax";
import AdvancedBanner from "../components/AdvancedBanner.js";
import { useNavigate } from 'react-router-dom';
import ContactConcierge from '../components/ContactConcierge.js';
import { DataContext } from '../App.js';
import BookingEngine from '../components/BookingEngine.js';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import Seo from '../components/Seo.js';
import CardsHome from '../components/CardsHome.js';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>
          {children}
        </div>

      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export const Home = () => {

  const context = useContext(DataContext)
  const mainRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const mobile = window.matchMedia("screen and (max-width: 767px)").matches;
  const tablet = window.matchMedia("screen and (min-width: 768px) and (max-width: 1199px)").matches;
  const laptop = window.matchMedia("screen and (min-width: 1200px) and (max-width: 1600px)").matches;
  const desktop = window.matchMedia("screen and (min-width: 1200px)").matches;
  const homePageContent = context.pages && context.pages.find(x => x.name === "home")?.pageContent;

  const villas = context.properties && context.properties.filter((x) => x.category === "villa" && x.status === "active" && x.isCarouselDisplay);

  const apartments = context.properties && context.properties.filter((x) => x.category === "apartment" && x.status === "active" && x.isCarouselDisplay);
  const experiences = context.properties && context.experiences.filter((x) => x.status === "active" && x.isCarouselDisplay).sort((a, b) => a.priority < b.priority ? 1 : -1);
  const offersSelected = [];


  experiences && experiences.map((x) => {
    x.offers.map((z, i) => {
      if (i > 0 && z.image !== null) {
        offersSelected.push({ image: (z.image[0] && (z.image[0].objectUrl ?? "")), title: z.title, description: z.description, url: `/experiences/${x.category}/${x.seoInformation.linkUrl}` });
      }
      return null
    })
    return null
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  useEffect(() => {
    const hasScrolled = () => window.scrollY > 0;

    const timer = setTimeout(() => {
      if (!hasScrolled() && (homePageContent?.cover?.isActive ?? false)) {
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      }
    }, 5000);

    const handleScroll = () => {
      if (hasScrolled()) {
        clearTimeout(timer);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [homePageContent?.cover?.isActive]);



  return (
    <>
      <Seo
        title={homePageContent?.seoInformation?.title ?? "Luxury villas and memorable experiences | Feeling Italy"}
        description={homePageContent?.seoInformation?.metaDescription ?? ""}
        keywords={homePageContent?.seoInformation?.keywords ?? ""}
        url={window.location.href}
      />
      {/* COVER */}
      {(homePageContent?.cover?.isActive ?? false) &&
        (
          <section className="row mx-0 vh-100 cover-home">
            {!mobile && !tablet && <div className="col-lg-7 col-12 overflow-hidden px-0 img-cover-home">
              {homePageContent?.cover && homePageContent?.cover?.image && homePageContent?.cover?.image[0]?.objectUrl && (
                <img src={process.env.REACT_APP_SITE_URL + (homePageContent?.cover?.image && (homePageContent?.cover?.image[0]?.objectUrl ?? ""))} alt={(homePageContent?.cover?.image && (homePageContent?.cover?.image[0]?.name ?? ""))} className="vh-100 w-fit-content">
                </img>
              )}
            </div>}
            <div className="col-lg-5 col-12 d-flex flex-column justify-content-center align-items-center background-black text-white pt-5 pb-5 pb-lg-0">
              <h4 className="cover-title text-white mb-4">{homePageContent?.cover.description}</h4>
              <h2 className="cover-title text-white text-center mb-5">{homePageContent?.cover.title}</h2>
              <img
                width="300"
                src={companyLogo}
                alt="Feeling Italy logo"
                className="mt-5 mb-5"
              />
              <div className="arrow-down-cta d-flex align-items-center flex-column mt-5">
                <HashLink
                  className="text-uppercase text-white cursor text-decoration-none d-flex align-items-center flex-column"
                  onClick={() => mainRef.current?.scrollIntoView({ behavior: 'smooth' })}
                  to={"/"}
                >
                  {homePageContent?.cover?.cta?.text ?? ""}
                  <FontAwesomeIcon icon={faChevronDown} className="mt-2 arrow-down-animation bounce cursor-pointer" />
                </HashLink>
              </div>

            </div>

          </section>)}

      <div ref={mainRef}></div>
      {!mobile && <div className="sectionVideoHome">
        <Header background={"transparent"} />
        <Video src={process.env.REACT_APP_SITE_URL + (homePageContent?.heading?.image && (homePageContent?.heading?.image[0]?.objectUrl ?? ""))} />
        <div className="col-lg-8 col-md-10 offset-md-1 custom-text-section-video col-10 offset-lg-1">
          <h3 dangerouslySetInnerHTML={{ __html: homePageContent?.heading?.title ?? "" }} className="text-white title fs-28" />
        </div>
      </div>}
      {mobile && <>
        <Header background={"transparent"} />
        <div className="sectionVideoHome">
          <Video src={process.env.REACT_APP_SITE_URL + (homePageContent?.heading?.image && (homePageContent?.heading?.image[0]?.objectUrl ?? ""))} />
        </div>
      </>
      }

      <BookingEngine isMobile={mobile} />

      {/* Carousel experiences */}
      <div className="text-center p-0 pt-5" id="carouselHome">
        <h4 className="title pt-5 text-center mb-4 px-2">{homePageContent?.intro?.title ?? ""}</h4>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          aria-label="tab"
          className="lineTabList p-0 pt-2"
        >
          <Tab label={t('Villas')} {...a11yProps(0)} className="tab-carousel-home me-4" />
          <Tab label={t('Apartments')} {...a11yProps(1)} className="tab-carousel-home me-4" />
          <Tab label={t('Experiences')} {...a11yProps(2)} className="tab-carousel-home" />

        </Tabs>
        <div index={value} onChange={handleChangeIndex}>

          <TabPanel className="effectSlowly" value={value} index={0}>
            {(villas.length < 5 && desktop) ? (
              <CardsHome cards={villas} />
            ) : (
              <CarouselCard elements={villas} />
            )}
          </TabPanel>
          <TabPanel value={value} index={1}>
          {(apartments.length < 5 && desktop) ? (
              <CardsHome cards={apartments} />
            ) : (
              <CarouselCard elements={apartments} />
            )}
          </TabPanel>
          <TabPanel value={value} index={2}>
          {(experiences.length < 5 && desktop) ? (
              <CardsHome cards={experiences} />
            ) : (
              <CarouselCard elements={experiences} />
            )}
          </TabPanel>

        </div>

        {value === 0 && (
          <button onClick={() => navigate("/property-collection", { state: { propertyType: 'villa' } })} className="bg-transparent text-black lineEffectBlack px-4 w-full text-left border-none text-uppercase">
            {t('SeeAllVillas')}
          </button>
        )}

        {value === 1 && (
          <button onClick={() => navigate("/property-collection", { state: { propertyType: 'apartment' } })} className="bg-transparent text-black lineEffectBlack px-4 w-full text-left border-none text-uppercase">
            {t('SeeAllApartments')}
          </button>
        )}

        {value === 2 && (
          <button onClick={() => navigate("/experiences", { state: { propertyType: 'villa' } })} className="bg-transparent text-black lineEffectBlack px-4 w-full text-left border-none text-uppercase">
            {t('SeeAllExperiences')}
          </button>
        )}
      </div>

      <section className="introductionConcierge padding-mobile introductionConcierge-Home">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-12 my-auto ps-3 text-left text-black">
              <h4 className={`mb-5 title ${(!mobile && !tablet) ? "text-center" : ""}`}>{homePageContent?.experiences[0]?.title}
              </h4>
              <div className={`mb-3 p-no-margin ${(!mobile && !tablet) ? "text-center" : ""}`} dangerouslySetInnerHTML={{ __html: homePageContent?.experiences[0]?.description }}>
              </div>
            </div>
          </div>
          <div className="row mt-5 d-flex align-items-stretch">
            <div className="col-lg-6 pe-lg-4 d-flex flex-column mb-4 mb-lg-0" >
              {homePageContent?.experiences && homePageContent?.experiences[1]?.image[0]?.objectUrl && (
                <img onClick={() => navigate(homePageContent?.experiences[1]?.cta?.url)} src={process.env.REACT_APP_SITE_URL + (homePageContent?.experiences[1]?.image && (homePageContent?.experiences[1]?.image[0]?.objectUrl ?? ""))} className="cursor-pointer h-100 w-100 object-fit-cover img-threeCards-first"
                  alt={homePageContent?.experiences[1]?.image && (homePageContent?.experiences[1]?.image[0]?.name ?? "")}
                />
              )}
              <div>
                <Link to={homePageContent?.experiences[1]?.cta?.url ?? "#"} className="text-black">
                  <h3 className="pt-4 lineEffectBlack text-uppercase text-left title">{homePageContent?.experiences[1]?.title}</h3>
                </Link>
                <div className="text-start p-no-margin pb-5" dangerouslySetInnerHTML={{ __html: homePageContent?.experiences[1]?.description ?? "" }}></div>
              </div>
            </div>

            <div className="col-lg-6 ps-lg-4 d-flex flex-column justify-content-between mb-4 mb-lg-0">
              <div>
                {homePageContent?.experiences && homePageContent?.experiences[2] && homePageContent?.experiences[2].image && homePageContent?.experiences[2]?.image[0] && homePageContent?.experiences[2]?.image[0]?.objectUrl && (
                  <img onClick={() => navigate(homePageContent?.experiences[2]?.cta?.url)} src={process.env.REACT_APP_SITE_URL + (homePageContent?.experiences[2]?.image && (homePageContent?.experiences[2]?.image[0]?.objectUrl ?? ""))} className="cursor-pointer h-auto w-100 object-fit-cover img-threeCards-right"
                    alt={homePageContent?.experiences[2]?.image && (homePageContent?.experiences[2]?.image[0]?.name ?? "")}
                  />
                )}
                <div>
                  <Link to={homePageContent?.experiences[2]?.cta?.url ?? ""} className="text-black">
                    <h3 className="pt-4 lineEffectBlack text-uppercase text-left title">{homePageContent?.experiences[2]?.title ?? ""}</h3>
                  </Link>
                  <div className="text-start p-no-margin pb-5" dangerouslySetInnerHTML={{ __html: homePageContent?.experiences[2]?.description ?? "" }}></div>
                </div>
              </div>

              <div>
                {homePageContent?.experiences && homePageContent?.experiences[3] && homePageContent?.experiences[3]?.image && homePageContent?.experiences[3]?.image[0]?.objectUrl && (
                  <img onClick={() => navigate(homePageContent?.experiences[3]?.cta?.url)} src={process.env.REACT_APP_SITE_URL + (homePageContent?.experiences[3]?.image && (homePageContent?.experiences[3]?.image[0]?.objectUrl ?? ""))} className="cursor-pointer h-auto w-100 object-fit-cover img-threeCards-right"
                    alt={homePageContent?.experiences[3]?.image && (homePageContent?.experiences[3]?.image[0]?.name ?? "")}
                  />
                )}
                <div>
                  <Link to={homePageContent?.experiences[3].cta?.url ?? ""} className="text-black">
                    <h3 className="pt-4 lineEffectBlack text-uppercase text-left title">{homePageContent?.experiences[3]?.title ?? ""}</h3>
                  </Link>
                  <div className={`text-start p-no-margin ${(mobile || tablet) ? "pb-2" : "pb-5"}`} dangerouslySetInnerHTML={{ __html: homePageContent?.experiences[3]?.description ?? "" }}></div>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div className={`d-flex justify-content-center padding-long-btn ${(!mobile && !tablet) ? "pt-5 mt-3 px-2" : ""}`}>
          <HashLink to={homePageContent?.experiences[0]?.cta?.url ?? ""} className="arrowEffectContainer background-black text-white py-3 px-4 w-lg-50 text-start border-none text-uppercase text-decoration-none">
            {homePageContent?.experiences[0]?.cta?.text ?? ""}<FontAwesomeIcon icon={faArrowRight} className="ms-2 effectArrow" color="white" fontSize={'16px'} />
          </HashLink>
        </div>
      </section>
      {/* Carousel offers */}
      {(offersSelected && offersSelected.length > 0) && (
      <div className="position-relative zIndex1 overflow-hidden">
        <section className="background-white introductionFeelingItaly">
          <h4 className={`title text-center text-uppercase mb-4 ${(mobile || tablet) ? "pt-2" : "pt-5"}`}>{t('FeaturedOffers')}</h4>
          <div className="container-fluid overflow-hidden text-center p-0" id="carouselOffers">
            <CarouselOffer offers={offersSelected ?? []} />
          </div>
        </section>
      </div>
      )}
      <div className="contact-home">
        <ContactConcierge margin={mobile ? '' : (tablet || laptop) ? '-200px' : '-180px'} />
      </div>
      <section>
        <div className="background-black home-parallax">
          <ParallaxProvider>
            <AdvancedBanner
              description={homePageContent?.concierge?.description ?? ""}
              title={homePageContent?.concierge?.title ?? ""}
              cta={homePageContent?.concierge?.cta}
              urlImage={homePageContent?.concierge?.image && (homePageContent?.concierge?.image[0]?.objectUrl ?? "")}
            />
          </ParallaxProvider>
        </div>
      </section>
    </>
  );
}